import React, { FC } from 'react';
import { SwitchProps } from './modules';
import { SwitchStyled } from './styles';

/**
 * A custom toggle switch component.
 *
 * @param props - The properties for the component.
 * @returns A React element representing the toggle switch.
 */
const Switch: FC<SwitchProps> = ({ checked, onChange, disabled }) => {
  return (
    <SwitchStyled
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      disabled={!!disabled}
    />
  );
};

export default Switch;
